export default __webpack_public_path__ + "static/media/market-gif2.1742c7d8.gif";